// removed by extract-text-webpack-plugin
module.exports = {"searchHeaderSection":"_31VAi","surveyContainer":"_1vvmu"};